import baseAPI from '@/http'

const router = 'api/acompanhamento/acompanhamentoPergunta'

export const attendanceQuestionAPI = {
  update: (attendanceQuestion) => baseAPI.put(router, attendanceQuestion),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(router)
}
